import { render, staticRenderFns } from "./scheduled-deliveries.vue?vue&type=template&id=31e3cd34&scoped=true"
import script from "./scheduled-deliveries.vue?vue&type=script&lang=js"
export * from "./scheduled-deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3cd34",
  null
  
)

export default component.exports